// extracted by mini-css-extract-plugin
export default {"search":"place-searcher_search__DZqxe","icon":"place-searcher_icon__Rau3c","searchList":"place-searcher_searchList__rlxgq","item":"place-searcher_item__szHhS"};